import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-950 via-purple-900 to-yellow-900 flex items-center justify-center p-4" data-testid="payment-cancel-page">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 text-center">
        <XCircle className="w-14 h-14 text-orange-500 mx-auto mb-3" />
        <h1 className="text-2xl font-black text-purple-900">Payment canceled</h1>
        <p className="text-sm text-zinc-700 mt-2">No charge was made. You can try again anytime from the My Account panel.</p>
        <Link
          to="/"
          className="inline-block mt-6 py-2.5 px-4 rounded-full bg-gradient-to-br from-purple-700 to-purple-900 text-white font-black text-sm shadow"
          data-testid="payment-cancel-home-btn"
        >
          <ArrowLeft className="w-3 h-3 inline mr-1" /> Back to MEGA! Chat
        </Link>
      </div>
    </div>
  );
}
